// images.js
import heroImage from "./home/hero-image.png"
import step1 from "./home/step1-pick.png"
import step2 from "./home/step2-checkin.png"
import step3 from "./home/step3-time.png"
import step4 from "./home/step4-space.png"
import step5 from "./home/step5-challenge.png"
import yogie from "./aboutUs/yogie.jpg"
import yulu from "./aboutUs/yulu.jpg"
import manato from "./aboutUs/manato.jpg"
import yungyung from "./aboutUs/yungyung.jpg"
import timelineScramble from "./gameIcons/timelineScramble.png";
import mirrorShot from "./gameIcons/mirrorShot.png";
import speechBubble from "./gameIcons/speechBubble.png";
import factFiction from "./gameIcons/factFiction.png";
import mindSnap from "./gameIcons/mindSnap.png";
import askAIGame from "./gameIcons/askAIGame.png"
import icon_camera from "./icons/Camera.png";
import icon_points from "./icons/icon_points.png";
import drawing_loc01 from "./checkpointsDrawing/loc1_drawing.png";
import drawing_loc02 from "./checkpointsDrawing/loc2_drawing.png";
import drawing_loc03 from "./checkpointsDrawing/loc3_drawing.png";
import drawing_loc04 from "./checkpointsDrawing/loc4_drawing.png";
import drawing_loc05 from "./checkpointsDrawing/loc5_drawing.png";
import drawing_loc06 from "./checkpointsDrawing/loc6_drawing.png";
import drawing_loc07 from "./checkpointsDrawing/loc7_drawing.png";
import drawing_loc08 from "./checkpointsDrawing/loc8_drawing.png";
import drawing_loc09 from "./checkpointsDrawing/loc9_drawing.png";
import drawing_loc10 from "./checkpointsDrawing/loc10_drawing.png";
import icon_profile from "./icons/icon_profile.jpg";
import icon_checkpoints from "./icons/icon_checkpoints.png";
import icon_quests from "./icons/icon_quests.png";
import picture_loc01 from "./checkpointPictures/loc1_01.jpg";
import picture_loc02 from "./checkpointPictures/loc2_01.jpg";
import picture_loc03 from "./checkpointPictures/loc3_01.jpg";
import picture_loc04 from "./checkpointPictures/loc4_01.jpg";
import picture_loc05 from "./checkpointPictures/loc5_01.jpg";
import picture_loc06 from "./checkpointPictures/loc6_01.jpg";
import picture_loc07 from "./checkpointPictures/loc7_01.jpg";
import picture_loc08 from "./checkpointPictures/loc8_01.jpg";
import picture_loc09 from "./checkpointPictures/loc9_01.jpg";
import picture_loc10 from "./checkpointPictures/loc10_01.jpg";

// Time travel images for each location
import stortorget_beforethe1600 from "./timeTravelInfoImagery/stortorget_beforethe1600.jpg";
import stortorget_1600s from "./timeTravelInfoImagery/stortorget_1600s.jpg";
import stortorget_1800s from "./timeTravelInfoImagery/stortorget_1800s.jpg";
import stortorget_2020s from "./timeTravelInfoImagery/stortorget_2020s.jpg";
import stortorget_1520 from "./timeTravelInfoImagery/stortorget_1520.jpg";
import stortorget_1700s from "./timeTravelInfoImagery/stortorget_1700s.jpg";
import stortorget_1901 from "./timeTravelInfoImagery/stortorget_1901.jpg";

import nobel_1895 from "./timeTravelInfoImagery/nobel_1895.jpg";
import nobel_1901 from "./timeTravelInfoImagery/nobel_1901.jpg";
import nobel_1929 from "./timeTravelInfoImagery/nobel_1929.jpg";
import nobel_2001 from "./timeTravelInfoImagery/nobel_2001.jpg";
import nobel_2010 from "./timeTravelInfoImagery/nobel_2010.jpg";
import nobel_2020 from "./timeTravelInfoImagery/nobel_2020.jpg";

import tyska_1571 from "./timeTravelInfoImagery/tyska_1571.jpg";
import tyska_1600 from "./timeTravelInfoImagery/tyska_1600.jpg";
import tyska_2020 from "./timeTravelInfoImagery/tyska_2020.jpg";
import tyska_1878 from "./timeTravelInfoImagery/tyska_1878.jpg";
import tyska_1945 from "./timeTravelInfoImagery/tyska_1945.jpg";

import kopmanbrinken_1300 from "./timeTravelInfoImagery/kopmanbrinken_1300.jpg";
import kopmanbrinken_1520 from "./timeTravelInfoImagery/kopmanbrinken_1520.jpg";
import kopmanbrinken_2020 from "./timeTravelInfoImagery/kopmanbrinken_2020.jpg";
import kopmanbrinken_1805 from "./timeTravelInfoImagery/kopmanbrinken_1805.jpg";
import kopmanbrinken_1956 from "./timeTravelInfoImagery/kopmanbrinken_1956.jpg";

import marten_1544 from "./timeTravelInfoImagery/marten_1544.jpg";
import marten_1800 from "./timeTravelInfoImagery/marten_1800.jpg";
import marten_2020 from "./timeTravelInfoImagery/marten_2020.jpg";
import marten_1605 from "./timeTravelInfoImagery/marten_1605.jpg";
import marten_1945 from "./timeTravelInfoImagery/marten_1945.jpg";

import palace_1697 from "./timeTravelInfoImagery/palace_1697.jpg";
import palace_1700 from "./timeTravelInfoImagery/palace_1700.jpg";
import palace_1754 from "./timeTravelInfoImagery/palace_1754.jpg";
import palace_1975 from "./timeTravelInfoImagery/palace_1975.jpg";
import palace_2020 from "./timeTravelInfoImagery/palace_2020.jpg";

import riddarholmen_1270 from "./timeTravelInfoImagery/riddarholmen_1270.jpg";
import riddarholmen_1500 from "./timeTravelInfoImagery/riddarholmen_1500.jpg";
import riddarholmen_2020 from "./timeTravelInfoImagery/riddarholmen_2020.jpg";
import riddarholmen_1679 from "./timeTravelInfoImagery/riddarholmen_1679.jpg";
import riddarholmen_1807 from "./timeTravelInfoImagery/riddarholmen_1807.jpg";

import runestone_1000 from "./timeTravelInfoImagery/runestone_1000.jpg";
import runestone_1600 from "./timeTravelInfoImagery/runestone_1600.jpg";
import runestone_2020 from "./timeTravelInfoImagery/runestone_2020.jpg";
import runestone_1200 from "./timeTravelInfoImagery/runestone_1200.jpg";
import runestone_1930 from "./timeTravelInfoImagery/runestone_1930.jpg";

import storkyrkan_1279 from "./timeTravelInfoImagery/storkyrkan_1279.jpg";
import storkyrkan_1489 from "./timeTravelInfoImagery/storkyrkan_1489.jpg";
import storkyrkan_2020 from "./timeTravelInfoImagery/storkyrkan_2020.jpg";
import storkyrkan_1306 from "./timeTravelInfoImagery/storkyrkan_1306.jpg";
import storkyrkan_1527 from "./timeTravelInfoImagery/storkyrkan_1527.jpg";
import storkyrkan_1742 from "./timeTravelInfoImagery/storkyrkan_1742.jpg";
import storkyrkan_2010 from "./timeTravelInfoImagery/storkyrkan_2010.jpg";

import ironboy_1954 from "./timeTravelInfoImagery/ironboy_1954.jpg";
import ironboy_1980 from "./timeTravelInfoImagery/ironboy_1980.jpg";
import ironboy_2020 from "./timeTravelInfoImagery/ironboy_2020.jpg";
import ironboy_1967 from "./timeTravelInfoImagery/ironboy_1967.jpg";
import ironboy_2003 from "./timeTravelInfoImagery/ironboy_2003.jpg";

// Space images for each location
import stortorget_prague_oldtownsquare from "./spaceTravelPictures/stortorget_prague_oldtownsquare.jpg";
import stortorget_sanmarco_venice from "./spaceTravelPictures/stortorget_sanmarco_venice.jpg";
import stortorget_krakow_mainmarket from "./spaceTravelPictures/stortorget_krakow_mainmarket.jpg";
import stortorget_grandplace_belgium from "./spaceTravelPictures/stortorget_grandplace_belgium.jpg";

import nobel_einstein_bern from "./spaceTravelPictures/nobel_einstein_bern.jpg";
import nobel_smithsonian_dc from "./spaceTravelPictures/nobel_smithsonian_dc.jpg";
import nobel_hiroshima_peacemuseum from "./spaceTravelPictures/nobel_hiroshima_peacemuseum.jpg";
import nobel_moli_dublin from "./spaceTravelPictures/nobel_moli_dublin.jpg";
import nobel_lindau_meeting from "./spaceTravelPictures/nobel_lindau_meeting.jpg";

import tyska_berlin_stnicholas from "./spaceTravelPictures/tyska_berlin_stnicholas.jpg";
import tyska_tallinn_stolaf from "./spaceTravelPictures/tyska_tallinn_stolaf.jpg";
import tyska_oslo_germanchurch from "./spaceTravelPictures/tyska_oslo_germanchurch.jpg";
import tyska_amsterdam_westerkerk from "./spaceTravelPictures/tyska_amsterdam_westerkerk.jpg";
import tyska_london_hamburgchurch from "./spaceTravelPictures/tyska_london_hamburgchurch.jpg";

import kopmanbrinken_coimbra_quebracostas from "./spaceTravelPictures/kopmanbrinken_coimbra_quebracostas.jpg";
import kopmanbrinken_kyoto_sannenzaka from "./spaceTravelPictures/kopmanbrinken_kyoto_sannenzaka.jpg";
import kopmanbrinken_venice_giantstairs from "./spaceTravelPictures/kopmanbrinken_venice_giantstairs.jpg";
import kopmanbrinken_istanbul_kamondo from "./spaceTravelPictures/kopmanbrinken_istanbul_kamondo.jpg";
import kopmanbrinken_paris_foyatier from "./spaceTravelPictures/kopmanbrinken_paris_foyatier.jpg";

import marten_prague_certovka from "./spaceTravelPictures/marten_prague_certovka.jpg";
import marten_reutlingen_spreuerhof from "./spaceTravelPictures/marten_reutlingen_spreuerhof.jpg";
import marten_exeter_parliament from "./spaceTravelPictures/marten_exeter_parliament.jpg";
import marten_tokyo_pissalley from "./spaceTravelPictures/marten_tokyo_pissalley.jpg";
import marten_rome_campanella from "./spaceTravelPictures/marten_rome_campanella.jpg";

import palace_versailles_france from "./spaceTravelPictures/palace_versailles_france.jpg";
import palace_buckingham_uk from "./spaceTravelPictures/palace_buckingham_uk.jpg";
import palace_hofburg_vienna from "./spaceTravelPictures/palace_hofburg_vienna.jpg";
import palace_tokyo_imperial from "./spaceTravelPictures/palace_tokyo_imperial.jpg";
import palace_amalienborg_denmark from "./spaceTravelPictures/palace_amalienborg_denmark.jpg";

import riddarholmen_westminster_abbey from "./spaceTravelPictures/riddarholmen_westminster_abbey.jpg";
import riddarholmen_saintdenis_france from "./spaceTravelPictures/riddarholmen_saintdenis_france.jpg";
import riddarholmen_elescorial_spain from "./spaceTravelPictures/riddarholmen_elescorial_spain.jpg";
import riddarholmen_stvitus_prague from "./spaceTravelPictures/riddarholmen_stvitus_prague.jpg";
import riddarholmen_speyer_germany from "./spaceTravelPictures/riddarholmen_speyer_germany.jpg";

import runestone_jelling_denmark from "./spaceTravelPictures/runestone_jelling_denmark.jpg";
import runestone_ruthwell_cross from "./spaceTravelPictures/runestone_ruthwell_cross.jpg";
import runestone_reykjavik_runestone from "./spaceTravelPictures/runestone_reykjavik_runestone.jpg";
import runestone_heavener_oklahoma from "./spaceTravelPictures/runestone_heavener_oklahoma.jpg";
import runestone_rokstone_sweden from "./spaceTravelPictures/runestone_rokstone_sweden.jpg";

import storkyrkan_notredame_paris from "./spaceTravelPictures/storkyrkan_notredame_paris.jpg";
import storkyrkan_canterbury_uk from "./spaceTravelPictures/storkyrkan_canterbury_uk.jpg";
import storkyrkan_cologne_germany from "./spaceTravelPictures/storkyrkan_cologne_germany.jpg";
import storkyrkan_seville_cathedral from "./spaceTravelPictures/storkyrkan_seville_cathedral.jpg";
import storkyrkan_nidaros_trondheim from "./spaceTravelPictures/storkyrkan_nidaros_trondheim.jpg";

import ironboy_mannekenpis_belgium from "./spaceTravelPictures/ironboy_mannekenpis_belgium.jpg";
import ironboy_littlemermaid_denmark from "./spaceTravelPictures/ironboy_littlemermaid_denmark.jpg";
import ironboy_hachiko_japan from "./spaceTravelPictures/ironboy_hachiko_japan.jpg";
import ironboy_ducklings_boston from "./spaceTravelPictures/ironboy_ducklings_boston.jpg";
import ironboy_unknownbureaucrat_iceland from "./spaceTravelPictures/ironboy_unknownbureaucrat_iceland.jpg";

import speechBubble_loc01 from "./speechBubblePictures/stortorget_speech.jpg";
import speechBubble_loc02 from "./speechBubblePictures/nobelMuseum_speech.jpg";
import speechBubble_loc03 from "./speechBubblePictures/tyskaKyrkan_speech.jpg";
import speechBubble_loc04 from "./speechBubblePictures/köpmanbrinken_speech.jpg";
import speechBubble_loc05 from "./speechBubblePictures/martenTrotzig_speech.jpg";
import speechBubble_loc06 from "./speechBubblePictures/royalPalace_speech.webp";
import speechBubble_loc07 from "./speechBubblePictures/riddarholm_speech.webp";
import speechBubble_loc08 from "./speechBubblePictures/runestone_speech.webp";
import speechBubble_loc09 from "./speechBubblePictures/storkyrkan_speech.jpg";
import speechBubble_loc10 from "./speechBubblePictures/ironBoy_speech.jpg";
import loc01_01 from "./spaceTravelPictures/loc01_01.jpg";
import loc01_02 from "./spaceTravelPictures/loc01_02.jpg";
import loc01_03 from "./spaceTravelPictures/loc01_03.jpg";
import loc01_04 from "./spaceTravelPictures/loc01_04.jpg";
import loc01_05 from "./spaceTravelPictures/loc01_05.jpg";
import loc02_01 from "./spaceTravelPictures/loc02_01.jpg";
import loc02_02 from "./spaceTravelPictures/loc02_02.jpg";
import loc02_03 from "./spaceTravelPictures/loc02_03.jpg";
import loc02_04 from "./spaceTravelPictures/loc02_04.jpg";
import loc02_05 from "./spaceTravelPictures/loc02_05.jpg";
import loc03_01 from "./spaceTravelPictures/loc03_01.jpg";
import loc03_02 from "./spaceTravelPictures/loc03_02.jpg";
import loc03_03 from "./spaceTravelPictures/loc03_03.jpg";
import loc03_04 from "./spaceTravelPictures/loc03_04.jpg";
import loc03_05 from "./spaceTravelPictures/loc03_05.jpg";
import loc04_01 from "./spaceTravelPictures/loc04_01.jpg";
import loc04_02 from "./spaceTravelPictures/loc04_02.jpg";
import loc04_03 from "./spaceTravelPictures/loc04_03.jpg";
import loc04_04 from "./spaceTravelPictures/loc04_04.jpg";
import loc04_05 from "./spaceTravelPictures/loc04_05.jpg";
import loc05_01 from "./spaceTravelPictures/loc05_01.jpg";
import loc05_02 from "./spaceTravelPictures/loc05_02.jpg";
import loc05_03 from "./spaceTravelPictures/loc05_03.jpg";
import loc05_04 from "./spaceTravelPictures/loc05_04.jpg";
import loc06_01 from "./spaceTravelPictures/loc06_01.jpg";
import loc06_02 from "./spaceTravelPictures/loc06_02.jpg";
import loc06_03 from "./spaceTravelPictures/loc06_03.jpg";
import loc06_04 from "./spaceTravelPictures/loc06_04.jpg";
import loc07_01 from "./spaceTravelPictures/loc07_01.jpg";
import loc07_02 from "./spaceTravelPictures/loc07_02.jpg";
import loc07_03 from "./spaceTravelPictures/loc07_03.jpg";
import loc07_04 from "./spaceTravelPictures/loc07_04.jpg";
import loc07_05 from "./spaceTravelPictures/loc07_05.jpg";
import loc08_01 from "./spaceTravelPictures/loc08_01.jpg";
import loc08_02 from "./spaceTravelPictures/loc08_02.jpg";
import loc08_03 from "./spaceTravelPictures/loc08_03.jpg";
import loc09_01 from "./spaceTravelPictures/loc09_01.jpg";
import loc09_02 from "./spaceTravelPictures/loc09_02.jpg";
import loc09_03 from "./spaceTravelPictures/loc09_03.jpg";
import loc09_04 from "./spaceTravelPictures/loc09_04.jpg";
import loc10_01 from "./spaceTravelPictures/loc10_01.jpg";
import loc10_02 from "./spaceTravelPictures/loc10_02.jpg";
import loc10_03 from "./spaceTravelPictures/loc10_03.jpg";
import loc10_04 from "./spaceTravelPictures/loc10_04.jpg";

import icon_back from "./icons/backIcon.png";

const images = {
  // Game Icons
  askAIGame,
  heroImage,
  step1,
  step2,
  step3,
  step4,
  step5,
  yogie,
  yulu,
  yungyung,
  manato,
  icon_camera,
  icon_back,
  icon_points,
  mindSnap,
  timelineScramble,
  mirrorShot,
  speechBubble,
  factFiction,
  drawing_loc01,
  drawing_loc02,
  drawing_loc03,
  drawing_loc04,
  drawing_loc05,
  drawing_loc06,
  drawing_loc07,
  drawing_loc08,
  drawing_loc09,
  drawing_loc10,
  icon_profile,
  icon_checkpoints,
  icon_quests,
  picture_loc01,
  picture_loc02,
  picture_loc03,
  picture_loc04,
  picture_loc05,
  picture_loc06,
  picture_loc07,
  picture_loc08,
  picture_loc09,
  picture_loc10,

  // Time Travel Info Images
  stortorget_beforethe1600,
  stortorget_1600s,
  stortorget_1800s,
  stortorget_2020s,
  stortorget_1520,
  stortorget_1700s,
  stortorget_1901,

  nobel_1895,
  nobel_1901,
  nobel_1929,
  nobel_2001,
  nobel_2010,
  nobel_2020,

  tyska_1571,
  tyska_1600,
  tyska_2020,
  tyska_1878,
  tyska_1945,

  kopmanbrinken_1300,
  kopmanbrinken_1520,
  kopmanbrinken_2020,
  kopmanbrinken_1805,
  kopmanbrinken_1956,

  marten_1544,
  marten_1800,
  marten_2020,
  marten_1605,
  marten_1945,

  palace_1697,
  palace_1700,
  palace_1754,
  palace_1975,
  palace_2020,

  riddarholmen_1270,
  riddarholmen_1500,
  riddarholmen_2020,
  riddarholmen_1679,
  riddarholmen_1807,

  runestone_1000,
  runestone_1600,
  runestone_2020,
  runestone_1200,
  runestone_1930,

  storkyrkan_1279,
  storkyrkan_1489,
  storkyrkan_2020,
  storkyrkan_1306,
  storkyrkan_1527,
  storkyrkan_1742,
  storkyrkan_2010,

  ironboy_1954,
  ironboy_1980,
  ironboy_2020,
  ironboy_1967,
  ironboy_2003,

  stortorget_prague_oldtownsquare,
  stortorget_sanmarco_venice,
  stortorget_krakow_mainmarket,
  stortorget_grandplace_belgium,
  nobel_einstein_bern,
  nobel_smithsonian_dc,
  nobel_hiroshima_peacemuseum,
  nobel_moli_dublin,
  nobel_lindau_meeting,
  tyska_berlin_stnicholas,
  tyska_tallinn_stolaf,
  tyska_oslo_germanchurch,
  tyska_amsterdam_westerkerk,
  tyska_london_hamburgchurch,

  kopmanbrinken_coimbra_quebracostas,
  kopmanbrinken_kyoto_sannenzaka,
  kopmanbrinken_venice_giantstairs,
  kopmanbrinken_istanbul_kamondo,
  kopmanbrinken_paris_foyatier,

  marten_prague_certovka,
  marten_reutlingen_spreuerhof,
  marten_exeter_parliament,
  marten_tokyo_pissalley,
  marten_rome_campanella,

  palace_versailles_france,
  palace_buckingham_uk,
  palace_hofburg_vienna,
  palace_tokyo_imperial,
  palace_amalienborg_denmark,

  riddarholmen_westminster_abbey,
  riddarholmen_saintdenis_france,
  riddarholmen_elescorial_spain,
  riddarholmen_stvitus_prague,
  riddarholmen_speyer_germany,

  runestone_jelling_denmark,
  runestone_ruthwell_cross,
  runestone_reykjavik_runestone,
  runestone_heavener_oklahoma,
  runestone_rokstone_sweden,

  storkyrkan_notredame_paris,
  storkyrkan_canterbury_uk,
  storkyrkan_cologne_germany,
  storkyrkan_seville_cathedral,
  storkyrkan_nidaros_trondheim,

  ironboy_mannekenpis_belgium,
  ironboy_littlemermaid_denmark,
  ironboy_hachiko_japan,
  ironboy_ducklings_boston,
  ironboy_unknownbureaucrat_iceland,

  speechBubble_loc01,
  speechBubble_loc02,
  speechBubble_loc03,
  speechBubble_loc04,
  speechBubble_loc05,
  speechBubble_loc06,
  speechBubble_loc07,
  speechBubble_loc08,
  speechBubble_loc09,
  speechBubble_loc10,
  loc01_01,
  loc01_02,
  loc01_03,
  loc01_04,
  loc01_05,
  loc02_01,
  loc02_02,
  loc02_03,
  loc02_04,
  loc02_05,
  loc03_01,
  loc03_02,
  loc03_03,
  loc03_04,
  loc03_05,
  loc04_01,
  loc04_02,
  loc04_03,
  loc04_04,
  loc04_05,
  loc05_01,
  loc05_02,
  loc05_03,
  loc05_04,
  loc06_01,
  loc06_02,
  loc06_03,
  loc06_04,
  loc07_01,
  loc07_02,
  loc07_03,
  loc07_04,
  loc07_05,
  loc08_01,
  loc08_02,
  loc08_03,
  loc09_01,
  loc09_02,
  loc09_03,
  loc09_04,
  loc10_01,
  loc10_02,
  loc10_03,
  loc10_04,
};

export default images;
